/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const HeadSEO = ({
  pageTitle,
  pageImgUrl,
  pageDescription,
  pageAltText,
  pageKeywords,
}) => {
  const defaultValues = {
    title: pageTitle === 'Science Museum of Minnesota'
      ? pageTitle
      : `${pageTitle} | Science Museum of Minnesota`,
    description: pageDescription || undefined,
    socialDescription:
      pageDescription
      || 'Turn on the science: Inspire learning. Inform policy. Improve lives.',
    altText: pageAltText || 'SMM building',
    imgUrl:
      pageImgUrl
      || 'https://images.ctfassets.net/x2t7lek2vf7h/54Xqq6iT6y8gXLx9VMukkj/451184db0692750a47b68ff0b142d7dd/smm-building.png',
    keywords: pageKeywords || 'science',
  };

  const {
    title,
    imgUrl,
    description,
    altText,
    keywords,
    socialDescription,
  } = defaultValues;

  // Use the Typekit / Adobe Fonts embed code to load Adobe Web fonts in a non-blocking fashion.
  const typekitEmbed = (typekitProjectID) => (
    <script>
      {`
        (function(d) {
          var config = {
            kitId: '${typekitProjectID}',
            scriptTimeout: 3000,
            async: true
          },
          h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
        })(document);
    `}
    </script>
  );

  return (
    <>
      <meta charSet="utf-8" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {/* open graph image tags */}
      <meta property="og:type" content="website" />
      <meta property="og:image" content={imgUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={socialDescription} />
      <meta property="og:image:width" content="961" />
      <meta property="og:image:height" content="541" />
      {/* twitter card */}
      <meta name="twitter:site" content="ScienceMuseumMN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={socialDescription} />
      <meta name="twitter:image" content={imgUrl} />
      <meta name="twitter:image:alt" content={altText} />
      {/* Proxima Nova SMM Web Fonts */}
      {typekitEmbed('qpz5kfp')}
    </>
  );
};

HeadSEO.propTypes = {
  pageAltText: PropTypes.string,
  pageDescription: PropTypes.string,
  pageImgUrl: PropTypes.string,
  pageKeywords: PropTypes.string,
  pageTitle: PropTypes.string.isRequired,
};

export default HeadSEO;
